import {Component, Input, OnInit} from '@angular/core';
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {CONTACT_LINKS, CONTACT_PHONE} from "../../constants";

@Component({
    selector: 'app-main-notification',
    templateUrl: './main-notification.component.html',
    styleUrls: ['./main-notification.component.scss'],
})
export class MainNotificationComponent implements OnInit {

    @Input() studentComment: string | null |undefined= '';
    @Input() childName: string | undefined = undefined;
    @Input() hasNotPaid: boolean | undefined = undefined;
    @Input() inReserved: boolean | undefined = undefined;
    @Input() withMarginBottom: boolean | undefined = undefined;

    protected readonly CONTACT_LINKS = CONTACT_LINKS;
    protected readonly CONTACT_PHONE = CONTACT_PHONE;


    constructor(  public myGcService: MyGreenCountry,) {

    }

    ngOnInit() {
    }

    openSocialLink(url: string) {

        this.myGcService.openUrl(url)
    }


}
